import 'sass/app.scss';

import _ from 'lodash';
import React from 'react';
import { ToastContainer } from 'react-toastify';
import { FooterLinks } from '../footer/footer-links';
import Footer from '../footer';
import {Link} from 'react-router-dom';


export class FanLandingMobile extends React.Component {
	constructor (props) {
		super(props);
	}

	render() {
		return (
			<div>
				<ToastContainer />
                <div className='landing-mobile'>
                    <div id="section-1" className="hero-crowd segment-1 fade-section margin-bottom-2">
                        <div className="funbox">
                            <p className="wumbo">Own Your Music</p>
                            <p className="mini">
                            The magic of music lives in the bond between artist and fan.<br/>
                            Back when you bought a record, you weren’t just playing songs — you were holding a piece of the story.<br/>
                            Streaming broke that. Muzado brings it back.<br/>
                            <br/>
                            This isn’t a rental.<br/>
                            You discover it.<br/>
                            You download it.<br/>
                            You keep it. Forever.
                            </p>
                        </div>
                    </div>
                    <div id="section-2" className="f-segment-2 margin-bottom-2 margin-top-2">
                        <div className="fan-cutout1 fs2-img-m"/>
                        <div className="wumbo">Subscribe. Curate. Keep.</div>
                        <div className="mini">
                            On Muzado, you don’t stream music — you own it.<br/>
                            Subscribe to your favorite artists and unlock access to everything they release: full tracks, exclusives, behind-the-scenes gems, and more.<br/>
                            <br/>
                            You get downloads on your terms — no buffering, no expiration, no platform strings attached.<br/>
                            <br/>
                            Build a personal catalog that’s actually yours.<br/>
                            Even if you unsubscribe, the music stays with you.<br/>
                        </div>
                    </div>
                    <div id="section-3" className="f-segment-3 margin-bottom-2 margin-top-2 text-blk">
                        <div className="fan-cutout2 fs3-img fade-section-m-white-1" style={{height:'35vh'}}/>
                        <div className="wumbo margin-top-1">Instant Drops, <br/>On Your Terms</div>
                        <div className="mini">
                            No more waiting for streaming platforms to catch up or relying on playlists to find new music.<br/>
                            <br/>
                            When artists you subscribe to release something, it’s available right here — ready for you to download and keep.<br/>
                            <br/>
                            No delays. No extra steps.<br/>
                            <br/>
                            Just new music, when you want it — yours to hold onto, forever.<br/>
                        </div>
                    </div>
                    {/* <div id="section-5" className="f-segment-5 margin-bottom-2 margin-top-2">
                        <div className="fan-splash s5-img-m"></div>
                        <div className="row expanded margin-top-1">
                            <div className="wumbo">The Digital Music Store</div>
                            <div className="mini">
                            Remember the thrill of flipping through vinyl and CDs at your favorite record store, uncovering hidden gems and reliving cherished memories? That nostalgic experience comes to life - digitally. Rediscover the joy of music as you once did in those aisles—every song is a story, and every listen a journey.   
                            </div>
                        </div>
                    </div> */}
                    <div id="section-4" className="f-segment-4 margin-bottom-2 margin-top-2">
                        <div id="section-6" className="f-segment-6">
                            <div className="fan-splash2 fs6-img fade-section-m-white-1">
                            </div>
                            <div className="wumbo" style={{marginTop:'5vh'}}>One Artist.<br/>One Price.<br/>One Year.</div>
                            <div className="mini">
                                It’s simple: $9.99 per artist, once a year.<br/>
                                <br/>
                                No monthly bills. No hidden fees. No surprise charges.<br/>
                                <br/>
                                Just full access to their catalog, instant drops, and downloads you keep — all for less than a t-shirt.<br/>
                                <br/>
                                Support the music you love, without the hassle.
                            </div>
                        </div>
                        <div className="f-segment-btm margin-top-2 margin-bottom-2">
                            <div className="hand-cutout s4-img-m column large-4 fade-section-m-purple"/>
                            <div className="column large-5" style={{paddingTop: '10vh', zIndex: '200'}}></div>
                            <div className="wumbo">Where Music<br/>Meets Fair Support</div>
                            <div className="mini">
                                Every subscription does more than unlock music — it directly supports the artists you love.<br/>
                                <br/>
                                Your $9.99 isn’t just access — it’s recognition. It’s respect. It’s fuel for what comes next.<br/>
                                <br/>
                                When you subscribe, you’re not just listening.<br/>
                                You’re part of the artist’s story.<br/>
                                <br/>
                                Support artists the way they deserve to be supported.<br/>
                                <br/>
                                And enjoy the music like it’s meant to be enjoyed — yours.
                            </div>
                            <div className="bg-squares s4-blocks"/>
                        </div>
                    </div>
                    {/* <div id="app-cta" className="app-cta">
                        <div className="wumbo">Get the App</div>
                        <div id="app-btn-holder" className="grid-x"></div>
                    </div> */}
                </div>
               
                
            </div>
		);
	}
}

export default FanLandingMobile;
